import { shouldTrack } from '$lib/global/tracking/helper';

import { getQueue, send } from './queue';

interface TrackingPayload {
    type?: string;
    event?: string;
    name?: string;
    traits?: Record<string, unknown>;
    properties?: Record<string, unknown>;
    [key: string]: unknown;
}

export const track = (data: TrackingPayload) => {
    return enqueue('/t', { ...data, type: 'track' });
};

export const page = (data: TrackingPayload) => {
    return enqueue('/p', { ...data, type: 'page' });
};

export const identify = (data: TrackingPayload) => {
    return enqueue('/i', { ...data, type: 'identify' });
};
export const enqueue = (path: string, message: TrackingPayload) => {
    if (!shouldTrack()) {
        return;
    }

    const url = `/ps-fnl-events/api/data${path}`;

    const queue = getQueue();

    // Send the request directly first with a timeout.
    send(
        message,
        url,
        (err: { status: string; responseText: string }) => {
            if (err) {
                const lastPart = url.split('/').reverse()[0];
                console.warn(`Direct Tracking Error: /${lastPart} - ${err.status}`, {
                    data: {
                        url,
                        message,
                        error: JSON.stringify(err),
                        status: err.status,
                        responseText: err.responseText,
                    },
                });

                // On failure, add to the queue for retry.
                queue.addItem({
                    url,
                    message,
                });
            }
        },
        2000,
    ); // Timeout set to 2 seconds, normal response time is 100-200ms
};

export default {
    track,
    page,
    identify,
};
